import React from "react";

const IconReporting = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 74 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.24 5.92H54.76C62.12 5.92 68.08 11.88 68.08 19.24V75.48C68.08 82.84 62.12 88.8 54.76 88.8H19.24C11.88 88.8 5.92 82.84 5.92 75.48V19.24C5.92 11.88 11.88 5.92 19.24 5.92ZM0 19.24C0 8.61 8.61 0 19.24 0H54.76C65.39 0 74 8.61 74 19.24V75.48C74 86.11 65.39 94.72 54.76 94.72H19.24C8.61 94.72 0 86.11 0 75.48V19.24ZM58.82 32.82C60.6 30.58 60.22 27.32 57.98 25.54C55.74 23.76 52.48 24.14 50.7 26.38L35.78 45.2C32.57 42.52 27.44 42.7 24.57 46.41L13.67 60.47C11.92 62.73 12.33 65.98 14.59 67.74C16.85 69.49 20.1 69.08 21.86 66.82L30.7 55.42C33.89 58.06 38.95 57.89 41.83 54.26L58.82 32.83V32.82Z"
      />
    </svg>
  );
};

export default IconReporting;
